import { DiscountPrice } from "@vp/swan";
import React, { useEffect, useState } from "react";

import { useLocalization } from "../hooks/useLocalizations";
import { Price, PricePresentationType, PriceProperties, PricesTypesBasedOnPricePresentation } from "../types/prices";
import { calculateTotalSavings, isDiscounted } from "../util/price-calculator-helper";

interface SavingsProps {
  prices: Record<PricesTypesBasedOnPricePresentation<PricePresentationType.PriceWithQtyAndUnit>, Price> & {
    unitListPriceForMoq: Price;
  }
  priceProperties: PriceProperties
}

// If savings exist, return the volume discount, or volume discount + sale message depending on the discount.
// If no savings are available, return null.

const Savings = ({ prices, priceProperties }: SavingsProps) => {
  const [totalSavingsMessage, setTotalSavingsMessage] = useState("");
  const [totalSaving, setTotalSaving] = useState(0);
  const { t } = useLocalization();

  useEffect(() => {
    if (!prices) return;

    const result = calculateTotalSavings(
      prices.unitListPrice,
      prices.unitDiscountedPrice,
      prices.unitListPriceForMoq,
      priceProperties.currency,
      priceProperties.vatInc,
    );

    setTotalSaving(result);
  }, [prices, priceProperties]);

  useEffect(() => {
    if (totalSaving > 0) {
      const message = isDiscounted(prices.totalListPrice, prices.totalDiscountedPrice, priceProperties.vatInc)
        ? t("price-platform.volume-discount-sale", { 0: totalSaving.toString() })
        : t("price-platform.volume-discount.value", { 0: totalSaving.toString() });
      setTotalSavingsMessage(message as string);
    }
  }, [totalSaving]);

  if (totalSaving === 0) return null;

  return totalSavingsMessage ? <DiscountPrice>{totalSavingsMessage}</DiscountPrice> : null;
};

export default Savings;
